export const hardNavigate = (url: string) => window.location.assign(url)
// "to" can be a path with search query included
export const toAbsoluteUrl = (to: string) => {
  return new URL(to, window.location.href).toString()
}
